/**
 * @typedef {Object} BookingFormGuestData данные гостя для формы бронирования
 * @property {string} name имя
 * @property {string} lastname фамилия
 * @property {string} patronymic отчество
 * @property {string} birthday дата рождения
 */

export const BookingFormGuestsStorage = (() => {
  /** Название поля в localStorage, соответствующего данным гостей для формы бронирования */
  const KEY = 'booking_form_guests_data';

  /** @type {Partial<BookingFormGuestData>[]} */
  const bookingFormGuestData = load();

  function load() {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(raw) ? raw : [];
    } catch {
      return [];
    }
  }

  function save() {
    localStorage.setItem(KEY, JSON.stringify(bookingFormGuestData));
  }

  return {
    get(index, field) {
      return bookingFormGuestData[index]?.[field];
    },
    set(index, field, value) {
      if (!bookingFormGuestData[index]) {
        bookingFormGuestData[index] = {};
      } else if (bookingFormGuestData[index][field] === value) {
        return;
      }
      bookingFormGuestData[index][field] = value;
      save();
    },
    setSize(requiredSize) {
      const currentSize = bookingFormGuestData.length;
      if (currentSize === requiredSize) {
        return;
      } else if (currentSize > requiredSize) {
        bookingFormGuestData.splice(requiredSize, currentSize - requiredSize);
      } else {
        bookingFormGuestData.push(...Array.from({ length: requiredSize - currentSize }, () => ({})));
      }
      save();
    },
    clear() {
      bookingFormGuestData.splice(0, bookingFormGuestData.length);
      save();
    },
  };
})();
